import React from 'react';
import styled from 'styled-components';
import { useNavigate } from 'react-router';
import { strings } from '/imports/strings';
import { useUser } from '/imports/hooks';
import { Icon } from '/imports/ui/Icon';


const NotFoundPageStyled = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  text-align: center;
  .wrapper {
    margin: auto;
  }
  p {
    text-align: center;
    font-size: 1.1rem;
  }
`;

/** 404 page; redirects unauthenticated visitors to login. */
export const NotFoundPage = () => {
  const user = useUser();
  const navigate = useNavigate();
  if (!user) navigate('/login');
  return (
    <NotFoundPageStyled className="page">
      <div className="wrapper">
        <Icon icon="warning" />
        <h2>{strings.NotFound()}</h2>
      </div>
    </NotFoundPageStyled>
  );
};